import { axiosFetch } from './axiosFetch';
import { postHeaders, getHeaders } from '../utils';
import API_CONSTANTS from '../constants/apiConstants';
import { urlModifier, parseURLParams } from '../utils/utils';

export const bulkPublishProjects = async ({
  destination,
  learningTool,
  bulkRequestId,
  requester,
  projects
}) => {
  const apiPath = API_CONSTANTS.BULK_PUBLISH_PROJECTS;
  const reqOptions = {
    ...postHeaders(),
    body: {
      destination,
      learningTool,
      bulkRequestId,
      requester,
      projects
    }
  };
  return axiosFetch(reqOptions, apiPath);
};

export const getUniquBulkRequestIds = async ({
  page,
  pageSize,
  sortOption,
  sortOptionOrder
}) => {
  const apiPath = API_CONSTANTS.GET_UNIQUE_BULK_REQUEST_IDS;
  const reqOptions = {
    ...getHeaders()
  };
  const params = {
    page,
    pageSize,
    sortOption,
    sortOptionOrder
  };
  const response = await axiosFetch(reqOptions, apiPath, params);
  return response.data;
};

export const getPublishStatusByBulkRequestId = async ({
  bulkRequestId,
  page,
  pageSize
}) => {
  const replacement = { '%bulkRequestId%': bulkRequestId };
  const url = parseURLParams(
    replacement,
    API_CONSTANTS.GET_BULK_PUBLISH_PROJECTS
  );
  const apiPath = urlModifier(url);
  const reqOptions = {
    ...getHeaders()
  };
  const params = {
    page,
    pageSize
  };
  const response = await axiosFetch(reqOptions, apiPath, params);
  return response.data;
};

export const getPostC6StatusByTxnIds = async ({ transactionIds }) => {
  const apiPath = API_CONSTANTS.GET_POST_C6_STATUS_BY_TXN_IDS;
  const payload = {
    transactionIds
  };
  const reqOptions = {
    ...postHeaders(),
    body: payload,
    config: { backgroundProcess: true }
  };

  const response = await axiosFetch(reqOptions, apiPath, {});
  return response.data;
};
